var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"editor-snapshots-author",style:(_vm.styles)},[_vm._v(_vm._s(_vm.params.author))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }